import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <Link to="/" className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                  <i className="ri-heart-pulse-line text-lg"></i>
                </div>
                <span className="text-lg font-semibold text-foreground-900 font-heading">
                  亲密发声指南
                </span>
              </Link>
              <p className="text-sm text-foreground-600 leading-relaxed">
                专业、温暖、科学的亲密发声学习平台，帮助成年伴侣提升亲密互动质量，探索声音表达的魅力。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4 font-heading">
                内容分类
              </h4>
              <ul className="flex flex-col gap-2">
                {categories.map((cat) => (
                  <li key={cat.id}>
                    <Link
                      to={`/category/${cat.id}`}
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4 font-heading">
                快速链接
              </h4>
              <ul className="flex flex-col gap-2">
                <li>
                  <Link to="/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                    首页
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                    关于我们
                  </Link>
                </li>
                <li>
                  <Link to="/category/jichu-rumen" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                    基础入门
                  </Link>
                </li>
                <li>
                  <Link to="/category/jinjie-jiqiao" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                    进阶技巧
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4 font-heading">
                联系与声明
              </h4>
              <ul className="flex flex-col gap-2 text-sm text-foreground-600">
                <li className="flex items-start gap-2">
                  <i className="ri-mail-line mt-0.5 text-foreground-400"></i>
                  <span>contact@auxnuyb.cn</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-shield-check-line mt-0.5 text-foreground-400"></i>
                  <span>本网站内容仅供成年用户学习参考</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-information-line mt-0.5 text-foreground-400"></i>
                  <span>所有内容均为教育目的，不构成医疗建议</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-background-200/70">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-xs text-foreground-500">
                &copy; {new Date().getFullYear()} 亲密发声指南. 保留所有权利.
              </p>
              <div className="flex items-center gap-4">
                <a
                  href="https://readdy.ai"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors"
                >
                  隐私政策
                </a>
                <a
                  href="https://readdy.ai"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors"
                >
                  使用条款
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}